import React from "react"
const daysOfWeek = ["S", "M", "T", "W", "T", "F", "S"]
export const handleWeekDays = (day) => {
  day._locale._weekdaysMin = daysOfWeek

  return <span>{day.format("D")}</span>
}



// WEBPACK FOOTER //
// ./src/components/DateRangePicker/utils/handleWeekDays.js